export const REWARDS_STATUS_BRONZE = 'BRONZE';
export const REWARDS_STATUS_SILVER = 'SILVER';
export const REWARDS_STATUS_GOLD = 'GOLD';
export const REWARDS_STATUS_PLATINUM = 'PLATINUM';
